// extracted by mini-css-extract-plugin
export default {"settings-container":"SettingsBody_settings-container__fhKCE"};